import type React from 'react';
import { styled } from 'styled-components';

import { Media } from '@/js/libs/ui';

import { AccountLink } from './AccountLink';

const AccountName = styled.p`
  margin: 0;
  @media ${Media.mdMin} {
    max-width: 300px;
  }
`;

type AccountProps = {
  id?: string;
  name?: string;
};

export const Account: React.FC<AccountProps> = ({ id, name }) => (
  <div>
    {id && <AccountLink id={id}>{`#${id}`}</AccountLink>}
    {name && <AccountName>{name}</AccountName>}
  </div>
);
